export default "__VITE_ASSET__MQhf9t4u__"